naiveShouldComponentUpdate = require 'lib/util/naive-should-component-update'
React = require 'react'
t = require('views/internal/recup-with-helpers')('select_member')
localizeCount = require 'lib/localize-count'
OrgFeatures = require 'data/org-features'

module.exports = class AutoCompleteMultiBoardGuestAlert extends React.Component
  displayName: 'AutoCompleteMultiBoardGuestAlert'

  constructor: (props) ->
    super(props)

  shouldComponentUpdate: naiveShouldComponentUpdate

  render: t.renderable ->
    {
      displayOrg
    } = @props

    owned = displayOrg?.owned()
    productCode = displayOrg?.get('paidAccount')?.products?[0]
    teamUrl = displayOrg?.get('url')

    t.div {
      onMouseDown: @onMouseDown.bind(@)
    }, ->
      if owned
        price = OrgFeatures.getPrice(productCode).toString()
        if OrgFeatures.isMonthly(productCode)
          t.format 'multi-board-guest-alert-as-admin-per-month', { price, learnMoreUrl: 'https://help.trello.com/article/1123-multi-board-guests' }
        else
          t.format 'multi-board-guest-alert-as-admin-per-year', { price, learnMoreUrl: 'https://help.trello.com/article/1123-multi-board-guests' }
      else
        if displayOrg?
          admins = displayOrg.adminList.map((member) -> member.get('fullName') || member.get('username'))
          if admins.length == 1
            t.format 'multi-board-guest-alert-as-member-with-1-admin', { admin1: admins[0], learnMoreUrl: 'https://help.trello.com/article/1123-multi-board-guests' }
          else if admins.length == 2
            t.format 'multi-board-guest-alert-as-member-with-2-admins', { admin1: admins[0], admin2: admins[1], learnMoreUrl: 'https://help.trello.com/article/1123-multi-board-guests' }
          else if admins.length == 3
            t.format 'multi-board-guest-alert-as-member-with-3-admins', { admin1: admins[0], admin2: admins[1], admin3: admins[2], learnMoreUrl: 'https://help.trello.com/article/1123-multi-board-guests' }
          else
            others = localizeCount 'others', admins.length - 3
            t.format 'multi-board-guest-alert-as-member-with-more-admins', { admin1: admins[0], admin2: admins[1], admin3: admins[2], others, othersUrl: "#{teamUrl}/members", learnMoreUrl: 'https://help.trello.com/article/1123-multi-board-guests' }
        else
          t.format 'multi-board-guest-alert-as-guest', { learnMoreUrl: 'https://help.trello.com/article/1123-multi-board-guests' }

  onMouseDown: (e) ->
    if e.target.classList.contains('stop-propagation')
      e.stopPropagation()
      if e.target.href
        window.open(e.target.href, '_blank')



// WEBPACK FOOTER //
// ./app/scripts/views/organization/invite-member-autocomplete-multi-board-guest-alert.coffee